<template>
  <div>
    <router-link
      :to="{ name: 'AddNewCategory' }"
      small
      class="ml-5"
    >
      New Category
    </router-link>
    <v-treeview
      class="mt-5"
      :items="items"
      item-key="item.name"
      open-on-click
    >
      <template v-slot:prepend="{ item }">
        <v-edit-dialog>
          <v-img
            :src="'/storage/' + item.image"
            lazy-src="/storage/default_img/no_image.png"
            aspect-ratio="1"
            max-width="50"
            max-height="50"
          />
          <template v-slot:input>
            <v-file-input
              v-model="category.image"
              label="Select File"
              placeholder="Upload Image"
              accept="image/jpg, image/png, image/jpeg"
              @change="uploadCategoryImage(item)"
            />
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:append="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editCategory(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="item.children.length < 1"
          small
          @click="warningCategoryRemove(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-treeview>
    <!-- Delete warning start -->
    <v-dialog
      v-model="categoryDelWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove this category ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="categoryDelWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeCategory"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    items: [],
    item: [],
    category: [],
    categoryDelWarning: false,
  }),
  mounted() {
    this.getCategoriesFromApi();
  },
  methods: {
    ...mapActions({
      snackbar: "snackbar/show",
    }),
    editCategory(item) {
      this.$router.replace({ name: "EditCategory", params: { id: item.id } });
    },
    uploadCategoryImage(category) {
      if (this.$data.category.image !== null) {
        let formData = new FormData();
        formData.append("image", this.category.image, this.category.image.name);
        window.axios
          .post(`/category-image/${category.id}`, formData)
          .then((response) => {
            this.getCategoriesFromApi();
            this.$data.category.image = null;
            this.snackbar(response.data.message);
          });
      }
    },
    removeCategory() {
      window.axios
        .delete("/category/" + this.$data.item.id)
        .then((response) => {
          this.getCategoriesFromApi();
          this.snackbar(response.data.message);
          this.categoryDelWarning = false;
        });
    },
    warningCategoryRemove(category) {
      this.item = category;
      this.categoryDelWarning = true;
    },
    getCategoriesFromApi() {
      window.axios.get("/categories-list").then((response) => {
        this.$data.items = response.data.list;
      });
    },
  },
};
</script>
